<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
    :config="config"
  >
  </cTable>
</template>

<script>
import { apis } from "@/api/finance/segmentDetails";
import cTable from "@/base/common/index";
export default {
  name: "extractList",
  components: {
    cTable,
  },
  props: {
    tabName: {
      type: String,
      default: "S_ALL",
    },
  },
  mounted() {
    this.config.tabName = this.tabName;
  },
  methods: {},
  data() {
    let dateTypeList = [
        {
          label: "clearance_date",
          value: "clearance_date",
        },
      ],
      keywordsTypeList = [
        { title: this.$t("BillInformation"), value: "extract" },
        {
          title: this.$t("packing") + this.$t("alipay_name"),
          value: "packing",
        },
        { title: this.$t("bag") + this.$t("alipay_name"), value: "packages" },
        { title: this.$t("orderNum"), value: "airway_number" },
      ],
      statusList = [
        { label: this.$t("Not") + this.$t("finish"), value: 0 },
        { label: this.$t("finish"), value: 1 },
      ];
    return {
      list: [],
      title: "",
      config: {
        slot: "div",
        rowId: "id",
        tabName: "",
        isGetList: true,
      },
      methods: {
        ...apis,
        list: (p) => {
          p.dataType = this.tabName;
          return apis.list(p);
        },
      },
      modals: {
        bayan: {
          config: {
            isNoPage: true,
            listFn: "bayan",
            title: this.$tz("bayan,文件"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$tz("文件,名称"),
                key: "title",
                minWidth: 110,
              },
              {
                name: () => this.$tz("操作人"),
                key: "create_name",
                minWidth: 110,
              },
              {
                name: () => this.$tz("上传,时间"),
                key: "create_time",
                minWidth: 110,
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 220,
                fixed: "right",
                list: [
                  {
                    name: this.$tz("下载"),
                    type: "down",
                    fnName: "down",
                    bind: {
                      type: "primary",
                    },
                    id: "",
                  },
                ],
                methods: {
                  down({ row }) {
                    window.open(row.src, "_blank");
                  },
                },
              },
            ],
          },
        },
        list: {
          methods: {
            list() {
              console.log(this.getSearchForm());
              let params = this.getSearchForm();
              let package_number_total = 0;
              let package_number = "";
              let keywords =
                params.keywords && params.keywords.replaceAll("\n", "");
              if (keywords) {
                this.list = this.originList.filter((t) => {
                  if (keywords.includes(t.airway_bill)) {
                    if (t.package_number != package_number) {
                      package_number_total += 1;
                      package_number = t.package_number;
                    }
                    return true;
                  } else return false;
                });
                this.package_number_total = package_number_total;
              } else {
                this.list = this.originList;
                this.package_number_total = this.origin_package_number_total;
              }
              this.airway_bill_total = this.list.length;
            },
          },
          config: {
            title: this.$tz("列表"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            header: {
              searchs: [
                {
                  key: "keywords",
                  placeholder() {
                    return this.$tz("订单号码");
                  },
                  component: "Input",
                  bind: {
                    type: "textarea",
                    autosize: { minRows: 2, maxRows: 2 },
                  },
                },
              ],
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill",
                copy: true,
                header: {
                  copy: true, //头部复制
                },
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("bagCode"),
                key: "package_number",

                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$tz("客户原单号"),
                key: "client_refer_code",
                minWidth: 110,
              },
              {
                name: () => this.$tz("申报价值"),
                key: "values",
                minWidth: 110,
              },
            ],
          },
        },
        fee: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                ids: row.ids,
                dataType: this.$page.config.tabName,
              });
              this.$page
                .handleRequestMethods("setExtractFinance", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("bayan,费用,设置"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bayan_fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              bayan_vat_rate: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { tm_values_total: 24 },
            { bayan_fee: 24 },
            { bayan_vat_rate: 24 },
          ],
          fields: [
            {
              name: () => this.$tz("TM,申报价值"),
              key: "tm_values_total",
              component: "Input",
              disabled: () => true,
              placeholder: () => this.$tz("TM,申报价值"),
            },
            {
              name: this.$tz("bayan,费用"),
              key: "bayan_fee",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              key: "bayan_vat_rate",
              name: () => this.$tz("bayan,税费,比例"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$tz("bayan,税费,比例"),
              bind: {
                formatter: (value) => `${value}%`,
                parser: (value) => value.replace("%", ""),
                style: "width:100%",
                min: 0,
              },
              default: 15,
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("OMS_MAWB_DATE_TYPE");
                field.options = res;
                searchForm[field.key] = res[0] && res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "fromStation",
            placeholder() {
              return this.$t("select") + this.$t("from_station");
            },
            component: "Select",
            config: {
              label: "name",
              value: "key",
            },
            options: [],
          },
          {
            key: "toStation",
            placeholder() {
              return this.$t("select") + this.$t("to_station");
            },
            component: "Select",
            config: {
              label: "name",
              value: "key",
            },
            options: [],
          },
          {
            name: this.$tz("目的机场"),
            key: "to_port",
            component: "Select",
            placeholder: () => this.$tz("目的机场"),
            options: [],
            optionsFn: "getAirPort",
            optionsKey: "",
            default: "",
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("finish") + this.$t("exlType");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: statusList,
          },
          {
            key: "clearance_agent",
            placeholder() {
              return this.$t("select") + this.$t("clearagent");
            },
            component: "Select",
            config: {
              label: "name",
              value: "key",
            },
            options: [],
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("OMS_MAWB_KEYWORDS");
                field.options = res.filter((t) =>
                  ["airway_number", "extract"].includes(t.value)
                );
                searchForm[field.key] = res[0] && res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return this.selectAll.length == 0;
              },
            },
            {
              name: () => this.$tz("bayan,费用,设置"),
              type: "fee",
              fnName: "fee",
              bind: {
                type: "primary",
              },
              disabled() {
                return this.selectAll.length == 0;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            fee({ row, field }) {
              this.getModal("fee").open({
                ids: this.selectAll.map((t) => t.id),
                tm_values_total: this.selectAll.reduce(
                  (a, b) => a + b.tm_values_total,
                  0
                ),
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "left",
          minWidth: 150,
          fixed: "left",
          copy: true,
          header: {
            copy: true, //头部 复制
          },
        },
        {
          name: () => this.$t("Clearance Start Time"),
          key: "clearance_start_date",
          minWidth: 120,
        },
        {
          name: () => this.$tz("清关结束时间"),
          key: "clearance_date",
          minWidth: 115,
        },

        {
          name: () => this.$t("to_station"),
          key: "to_station",
          minWidth: 80,
        },
        {
          name: () => this.$tz("目的机场"),
          key: "to_port",
          minWidth: 110,
        },
        {
          name: () => this.$t("clearagent"),
          key: "clearance_agent",
          minWidth: 120,
        },
        {
          name: () => this.$tz("TM,计费重"),
          key: "tm_charge_weight",
          minWidth: 110,
        },
        {
          name: () => this.$tz("总计费重"),
          key: "total_charge_weight",
          minWidth: 110,
        },
        {
          name: () => this.$tz("TM,票数"),
          key: "tm_airway_bill_total",
          minWidth: 110,
        },
        {
          name: () => this.$tz("TM,申报价值"),
          key: "tm_values_total",
          minWidth: 110,
        },
        {
          name: () => this.$t("number_of_bags"),
          key: "quantity",
          minWidth: 115,
        },
        {
          name: () => this.$t("cod_number"),
          key: "airway_bill_total",
          minWidth: 115,
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          minWidth: 115,
          bind: {
            style({ row }) {
              if (row.weight > row.total_charge_weight) {
                return {
                  color: "red",
                };
              }
            },
          },
        },
        {
          name: () => this.$tz("bayan"),
          key: "bayan_fee_info.bayan",
          minWidth: 110,
        },
        {
          name: () => this.$tz("bayan,税费,比例"),
          key: "bayan_fee_info.bayan_vat_rate",
          minWidth: 110,
        },
        {
          name: () => this.$tz("bayan,总金额"),
          key: "bayan_fee_info.total_amount",
          minWidth: 110,
        },
        {
          name: () => this.$tz("bayan,操作人"),
          key: "bayan_fee_info.operator_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("bayan,操作时间"),
          key: "bayan_fee_info.create_time",
          minWidth: 110,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          width: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 115,
        },
        {
          name: () => this.$t("createUser"),
          key: "creator_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: () => this.$tz("列表"),
              type: "show",
              fnName: "show",
              bind: {
                type: "primary",
              },
            },
            {
              name: this.$tz("提单,导出"),
              type: "mawb",
              fnName: "export",
              bind: {
                type: "primary",
              },
              id: "",
            },
            {
              name: () => this.$tz("包裹,导出"),
              type: "package",
              fnName: "export",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("bayan"),
              type: "bayan",
              bind: {
                type: "primary",
              },
              fnName: "bayan",
            },
          ],
          methods: {
            bayan({ row }) {
              this.getModal("bayan").open(row, function () {
                this.setTitle(this.$tz("bayan"));
                this.pageConfig.data.id = row.id;
                this.pageConfig.data.dataType = this.$page.config.tabName;
                this.getList();
              });
            },
            show({ row }) {
              this.handleRequestMethods(
                "tmExtractDetails",
                { id: row.id, dataType: this.config.tabName },
                false,
                true
              ).then((res) => {
                this.getModal("list").open(row, function () {
                  this.setTitle(this.$tz("列表") + `${row.mawb}`);
                  this.list = res.payload.row;
                  this.originList = res.payload.row;
                  this.airway_bill_total = res.payload.airway_bill_total;
                  this.package_number_total = this.origin_package_number_total =
                    res.payload.package_number_total;
                  this.table.fields[1].name = () => {
                    return (
                      this.$t("order_number") + `(${this.airway_bill_total})`
                    );
                  };
                  this.table.fields[2].name = () => {
                    return (
                      this.$t("bagCode") + `(${this.package_number_total})`
                    );
                  };
                });
              });
            },
            export({ row, field }) {
              if (field.type == "package") {
                console.log(this.methods);
                this.handleRequestMethods(
                  "bgTdExport",
                  { id: row.id, dataType: this.config.tabName },
                  true,
                  true
                ).then((res) => {
                  console.log(res);
                  window.open(this.$globalUrl + res.payload, "_blank");
                });
              } else {
                this.handleRequestMethods(
                  "tdExport",
                  { ids: [row.id], dataType: this.config.tabName },
                  true,
                  true
                ).then((res) => {
                  console.log(res);
                  window.open(this.$globalUrl + res.payload, "_blank");
                });
              }
            },
          },
        },
      ],
    };
  },
};
</script>
